import { render } from "./UserTop.vue?vue&type=template&id=998482d6"
import script from "./UserTop.vue?vue&type=script&lang=js"
export * from "./UserTop.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__